import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClosedCaptioning, faLanguage, faFilm, faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import TranslateIcon from "@/Components/Icons/TranslateIcon";
import useTranslations from "@/hooks/useTranslations";

type Props = {
    hours: number;
};

function formatHours(hours: number): string {
    if (hours < 1) {
        return `${Math.round(hours * 60)} min`;
    }
    if (hours === Math.floor(hours)) {
        return `${hours}h`;
    }
    return `${hours.toFixed(1)}h`;
}

export default function CreditsUsageBreakdown({ hours }: Props) {
    const { __ } = useTranslations();
    const extractionRate = laravelConfig<number>('pricing.credit_rates.extraction', 1);
    const translationRate = laravelConfig<number>('pricing.credit_rates.translation', 0.5);
    const burnInRate = laravelConfig<number>('pricing.credit_rates.burn_in', 1);
    const extraction = hours / extractionRate;
    const translation = hours / translationRate;
    const burnIn = hours / burnInRate;

    return (
        <div className="p-4 w-[15.5rem]">
            <ul className="space-y-2.5">
                <li className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2">
                        <FontAwesomeIcon icon={faAlignLeft} className="text-blue-500 w-4" />
                        <span className="text-sm text-gray-700 dark:text-gray-300">{__('common.credits.subtitle_extraction')}</span>
                    </div>
                    <span className="font-semibold text-gray-900 dark:text-gray-100 text-sm">{formatHours(extraction)}</span>
                </li>
                <li className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-2">
                        <FontAwesomeIcon icon={faFilm} className="text-purple-500 w-4" />
                        <span className="text-sm text-gray-700 dark:text-gray-300">{__('common.credits.video_export')}</span>
                    </div>
                    <span className="font-semibold text-gray-900 dark:text-gray-100 text-sm">{formatHours(burnIn)}</span>
                </li>
                <li className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1">
                        <TranslateIcon className="text-green-500 w-4" />
                        <span className="text-sm text-gray-700 dark:text-gray-300">{__('common.credits.translation')}</span>
                    </div>
                    <span className="font-semibold text-gray-900 dark:text-gray-100 text-sm">{formatHours(translation)}</span>
                </li>
            </ul>
        </div>
    );
}
